import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const ServerStoreDataContext = /*#__PURE__*/ React.createContext({
    storeCode: undefined
});
const useServerStoreDataContext = ()=>React.useContext(ServerStoreDataContext)
;
function withServerStoreDataContext() {
    return ()=>{
        return (PageComponent)=>{
            const WithServerStoreDataContext = (pageProps)=>{
                var ref1;
                const value = React.useMemo(()=>{
                    var ref;
                    return {
                        storeCode: pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.storeData) === null || ref === void 0 ? void 0 : ref.code
                    };
                }, [
                    pageProps === null || pageProps === void 0 ? void 0 : (ref1 = pageProps.storeData) === null || ref1 === void 0 ? void 0 : ref1.code
                ]);
                return /*#__PURE__*/ React.createElement(ServerStoreDataContext.Provider, {
                    value: value
                }, /*#__PURE__*/ React.createElement(PageComponent, swcHelpers.extends({}, pageProps)));
            };
            if (typeof PageComponent.getInitialProps === 'function') {
                WithServerStoreDataContext.getInitialProps = PageComponent.getInitialProps;
            }
            if (process.env.NODE_ENV !== 'production') {
                const displayName = PageComponent.displayName || PageComponent.name || 'Unknown';
                WithServerStoreDataContext.displayName = `WithServerStoreDataContext(${displayName})`;
            }
            return WithServerStoreDataContext;
        };
    };
}

export { ServerStoreDataContext, useServerStoreDataContext, withServerStoreDataContext };
//# sourceMappingURL=with-server-store-data-context.js.map
